import { useAppDispatch, useAppSelector } from '@/hooks'
import { useState } from 'react'
import { selectPlan } from '@/actions/plans'
import { FlowStep, Question } from 'app-components'
import { CardActionButton, CardActions, CardNavigation } from '@/components'
import UtilityPlanDropdown from 'features/utilities/UtilityPlanDropdown'
import { programsNewCollection } from '@/reducers/programsNew'

type Props = {
  onComplete?: () => void
}

function useViewModel(props: Props) {
  const dispatch = useAppDispatch()
  const [selectedPlanId, setSelectedPlanId] = useState<
    number | undefined | null
  >()
  const isLoading = useAppSelector(
    (state) => state.plans.isLoading || state.utilities.isLoading,
  )

  const onChange = (planId: number) => {
    setSelectedPlanId(planId)
  }

  const onFinish = () => {
    dispatch(selectPlan({ plan_id: selectedPlanId }))
      .then(() => {
        props.onComplete?.()
      })
      // Refresh the MP Program collection after a plan has been chosen
      .then(() => dispatch(programsNewCollection.actions.invalidate()))
  }

  const disabled = isLoading || !selectedPlanId

  return { selectedPlanId, onChange, onFinish, disabled }
}

export default function SelectUtilityPlanFlowStep(props: Props) {
  const { onChange, selectedPlanId, disabled, onFinish } = useViewModel(props)

  return (
    <FlowStep id="select-utility-plan-flow">
      <FlowStep.Content>
        <CardNavigation id="select-utility-plan-card-navigation" />
        <Question
          title="What is your utility plan?"
          subtitle="Select your utility plan to integrate your exact electricity rates"
        >
          <UtilityPlanDropdown
            label="Select utility plan"
            onChange={onChange}
            selectedPlanId={selectedPlanId ?? undefined}
          />
        </Question>
      </FlowStep.Content>
      <FlowStep.Actions>
        <CardActions>
          <CardActionButton
            type="primary"
            id="select-utility-plan-card-select-button"
            disabled={disabled}
            onClick={onFinish}
          >
            Next
          </CardActionButton>
        </CardActions>
      </FlowStep.Actions>
    </FlowStep>
  )
}
